/**
 * onboardingCache.js
 *
 * Module-level cache for onboarding config data fetched once in App.js.
 * Pages read from this cache to merge API highlights into their local tour steps.
 */

let _cache = null;

/** Called once from App.js after the API responds */
export function setOnboardingCache(data) {
  _cache = data; // array of { screen, isCompleted, highlights: [...] }
}

/**
 * Returns highlights for a given screen key, or [] if not loaded yet.
 * @param {string} screen - e.g. 'dashboard', 'events', 'profile'
 * @returns {Array} highlights from the API
 */
export function getHighlightsForScreen(screen) {
  if (!_cache) return null; // API not loaded yet
  const entry = _cache.find((s) => s.screen === screen);
  if (entry?.isCompleted) {
    return null; // The backend says it's completed
  }
  return entry?.highlights ?? [];
}
